export const InvoiceBeforeAfterReducer = (
    state = {
        records: [
            { dayId: 0, description: "Before" },
            { dayId: 1, description: "After" }
        ]
    }) => { return state }